import type { ProfileDetail } from "@/interface/auth";

function DataItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="space-y-1">
      <span className="text-xs font-semibold text-slate-500">{label}</span>
      <p className="text-sm font-medium text-slate-900 dark:text-white">
        {value || "N/A"}
      </p>
    </div>
  );
}

export function PersonalTab({ profile }: { profile?: ProfileDetail | null }) {
  const fullName = profile
    ? `${profile.first_name || ""} ${profile.last_name || ""}`.trim()
    : "";

  return (
    <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 shadow-sm">
      <h2 className="text-lg font-bold text-primary mb-6 border-b border-slate-100 dark:border-slate-800 pb-4">
        Personal Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <DataItem label="Full Name" value={fullName} />
        <DataItem label="Date of Birth" value={profile?.birth_date || ""} />
      </div>
      <h3 className="text-sm font-bold text-slate-900 dark:text-white mb-4">
        Address Details
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="md:col-span-2">
          <DataItem label="Address" value={profile?.address || ""} />
        </div>
        <DataItem label="City" value={profile?.city || ""} />
        <DataItem label="State" value={profile?.state || ""} />
        <DataItem label="Country" value={profile?.country || ""} />
        <DataItem label="Postal Code" value={profile?.postal_code || ""} />
      </div>
      {profile?.summary && (
        <div className="mt-8 pt-6 border-t border-slate-100 dark:border-slate-800">
          <h3 className="text-sm font-bold text-slate-900 dark:text-white mb-2">
            Professional Summary
          </h3>
          <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed whitespace-pre-line">
            {profile.summary}
          </p>
        </div>
      )}
    </div>
  );
}
